import React from 'react';
import { componentService } from 'js/services/component.service';

import style from './Loader.scss';

export const Loader = ({ className = '' }) => (
    <div className={`${style.loader} ${className} loader`}>
        <div className={style.rect1} />
        <div className={style.rect2} />
    </div>
);

componentService.registerWebContentComponents({ Loader });
